import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class ReviewsSlider {
    constructor() {
        this.slider = document.querySelector('.reviewsSwiper');
        if (!this.slider) return;

        this.progressIndicator = document.querySelector('.reviews .reviews__progressIndicator');
        this.section = document.querySelector('.reviews');

        this.init();
    }

    init() {
        this.initSwiper();
        this.animateOnScroll();
        this.animateSlideContent(this.swiper.slides[this.swiper.activeIndex]);
    }

    initSwiper() {
        this.swiper = new Swiper(this.slider, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 200,
            speed: 800,
            navigation: {
                nextEl: '.reviews__navBtn--next', // 👈 Sélecteur unique
                prevEl: '.reviews__navBtn--prev', // 👈 Sélecteur unique
            },
            on: {
                slideChange: (swiper) => this.updateProgress(swiper),
                init: (swiper) => this.updateProgress(swiper),
                slideChangeTransitionStart: (swiper) => this.onSlideChange(swiper),
            },
        });
    }

    updateProgress(swiper) {
        const totalSlides = swiper.slides.length;
        const indicatorWidth = 100 / totalSlides;
        const position = (swiper.activeIndex / (totalSlides - 1)) * (100 - indicatorWidth);

        this.progressIndicator.style.width = `${indicatorWidth}%`;
        this.progressIndicator.style.left = `${position}%`;
    }

    destroy() {
        if (this.swiper) this.swiper.destroy();
    }

    animateOnScroll() {
        gsap.from(this.section, {
            y: 50,
            opacity: 0,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
                trigger: this.section,
                start: 'top 80%',
                end: 'top 50%',
                toggleActions: 'play none none reverse',
            },
        });
    }

    onSlideChange(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        this.animateSlideContent(activeSlide);
    }

    animateSlideContent(slide) {
        if (!slide) return;

        const contentElements = slide.querySelectorAll('.reviews__slider__slide');

        gsap.fromTo(
            contentElements,
            { opacity: 0 },
            { opacity: 1, duration: 1.3, delay: 0.5 }
        );
    }
}